import http from 'http/index';

const { REACT_APP_CAS_API_PATH = '', REACT_APP_PATH } = process.env;
const API = http.defaults.baseURL;

// eslint-disable-next-line import/prefer-default-export
export const cas3ApiRoute = (endpoint) => `${API.replace(REACT_APP_PATH, REACT_APP_CAS_API_PATH)}${endpoint}`;
